import { PrimaryButton, WarningBanner } from "@graffer-inc/console-design-kit";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { resolveSAMLErrorMessage } from "../../../application/domain/auth/saml-error";
import { useAuthContextV2 } from "../../../auth-state";
import { parseQueryOfLocation } from "../../../utils/url-utils";
import { LoginTemplate } from "../../template/login-template";

export const SSOLoginErrorPage = () => {
  const history = useHistory();
  const authCtx = useAuthContextV2();
  const { errorCode } = parseQueryOfLocation(useLocation()) as {
    errorCode?: string;
  };
  const errorMessage = errorCode ? resolveSAMLErrorMessage(errorCode) : "";

  if (authCtx.auth.isAuthed || !errorCode) {
    return <Redirect to="/" />;
  }

  return (
    <LoginTemplate>
      <div className="my-5">
        <WarningBanner
          message="シングルサインオンでエラーが発生しました"
          description={`エラーコード [${errorCode}]: ${errorMessage}`}
        />
      </div>
      <div className="has-text-centered">
        <PrimaryButton
          text="ログイン画面に戻る"
          onClick={() => history.push("/login")}
        />
      </div>
    </LoginTemplate>
  );
};
